import { Dialog, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import { theme } from "../styles/theme";
// import { Subscriptions } from "./companyRegistration/subscriptions";
import { StripePayment } from "./companyRegistration/subscriptions/stripePayment";
import CancelIcon from "@mui/icons-material/Cancel";
import { useContext } from "react";
import { ApplicationContext } from "../context/application_ctx";

export const SubscriptionDialog = ({
  profileDetails,
  demoExpired,
  selectedNoOfEmployees,
  paymentAmount
}) => {
  // context
  const {
    subDialog,
    setSubDialog,
    subscriptionNav,
    setSubscriptionNav,
    setProfileSnack,
    setError,
  } = useContext(ApplicationContext);

  const handleClose = () => {
    setSubDialog(false);
    setSubscriptionNav(false);
  };
console.log(selectedNoOfEmployees,'selected')
  return (
    <>
      <Dialog
        open={subDialog}
        fullWidth
        maxWidth={"100%"}
        maxheight={"100%"}
        PaperProps={{
          style: {
            maxHeight: "100%",
            width: "570px",
          },
        }}
        onClose={handleClose}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="13px"
          width="100%"
          padding={"19px 0px"}
          backgroundColor={theme.col_4}
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-end"
            width="94%"
            position="absolute"
          >
            <IconButton onClick={handleClose}>
              <CancelIcon sx={{ fontSize: "32px", color: theme.col_2 }} />
            </IconButton>
          </Box>

          <StripePayment
          paymentAmount={paymentAmount}
            selectedNoOfEmployee={selectedNoOfEmployees}
            setSubDialog={setSubDialog}
            setSubscriptionNav={setSubscriptionNav}
            setError={setError}
            setSignInSnack={setProfileSnack}
            upgrade={true}
          />
          {subscriptionNav ? (
            <></>
          ) : (
            <></>
            // <Subscriptions
            //   demoExpired={demoExpired}
            //   upgrade={true}
            //   setSubscriptionNav={setSubscriptionNav}
            // />
          )}
          {/* <StripePayment upgrade={true} /> */}
        </Box>
      </Dialog>
    </>
  );
};
